import {
    convertCurrencyFormatPositiveNegative,
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer, RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator,
    RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoMobileInputOutlined,
    RaikoNumberInputOutlined,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useParams} from "react-router-dom";
import {VowService} from "../../../serverService/vow/VowService";
import DashboardVowReports from "../../dashboard/vowReport/DashboardVowReports";
import React, {useEffect, useState} from "react";
import {useDebounce} from "@uidotdev/usehooks";
import RaikoDrawer, {RaikoDrawerDirection} from "../../../raikoComponents/raikoDrawer/RaikoDrawer.tsx";
import {Helmet} from "react-helmet";
import {RouteHelper} from "../../../route/RouteHelper";

export default function VowTransactions() {
    const {id: vowId = -1} = useParams()
    const service = new VowService();

    let page = 0
    const size = 20

    const [fullName, setFullName] = useState("")
    const [nationalCode, setNationalCode] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")

    const fullNameFilter = useDebounce(fullName, 300)
    const nationalCodeFilter = useDebounce(nationalCode, 300)
    const phoneNumberFilter = useDebounce(phoneNumber, 300)

    const [transactions, setTransactions] = useState([])
    const [pageCount, setPageCount] = useState(0)
    const [numberOfItems, setNumberOfItems] = useState(0)
    const [tableLoading, setTableLoading] = useState(false)

    useEffect(() => {
        getDataFromServer();
    }, [
        fullNameFilter,
        nationalCodeFilter,
        phoneNumberFilter
    ]);

    function prepareItem(number, id, fullName, nationalCode, phoneNumber, amount, createdAt, paymentGatewayTitle) {
        return {
            number,
            id,
            fullName,
            nationalCode,
            phoneNumber,
            amount: convertCurrencyFormatPositiveNegative(amount / 10),
            createdAt: convertUniversalDateTimeToPersianDateTime(createdAt),
            paymentGatewayTitle
        }
    }

    function getDataFromServer() {
        setTableLoading(true)
        service.getVows(
            vowId,
            page,
            size,
            fullNameFilter,
            nationalCodeFilter,
            phoneNumberFilter
        ).then(response => {
            setNumberOfItems(response.numberOfItems)
            setPageCount(response.totalPage)

            setTransactions([])
            response.data.map((vow, index) => {
                setTransactions(prevState => [
                    ...prevState,
                    prepareItem(
                        (page * size) + index + 1,
                        vow.id,
                        `${vow.firstName} ${vow.lastName}`,
                        vow.nationalCode ? vow.nationalCode : '-',
                        vow.phoneNumber ? vow.phoneNumber : '-',
                        vow.amount,
                        vow.createdAt,
                        vow.paymentGatewayTitle
                    )
                ])
            })

        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoading(false)
        })
    }


    function handlePaginationChange(newPage) {
        page = newPage
        getDataFromServer()
    }

    function handleShowDetail(transactionId) {

    }

    return (
        <>
            {/*<RaikoDrawer anchor={RaikoDrawerDirection.BOTTOM} openDrawer={false}>*/}
            {/*    show detail of transaction*/}
            {/*</RaikoDrawer>*/}
            <Helmet><title>{RouteHelper.VowPayments.name}</title></Helmet>

                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    {vowId !== -1 ?
                        <DashboardVowReports vowId={vowId}/>
                        : ""
                    }
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Vow.name,
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.VowPayments.name,
                                ""
                            ),
                        ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                            <RaikoTableTitleContainer
                                title={"پرداخت ها"}
                                amount={numberOfItems}
                                amountTitle={"تراکنش موفق"}
                            />

                            <RaikoTableSearchContainer
                                labelText={"نام و نام خانوادگی"}
                                hasFilter
                                value={fullName}
                                setValue={setFullName}
                                filterStatus={
                                    (nationalCodeFilter && nationalCodeFilter.length > 0) ||
                                    (phoneNumberFilter && phoneNumberFilter.length > 0)}
                                handleDeleteAllFilters={_ => {
                                    setNationalCode("")
                                    setPhoneNumber("")
                                }}

                            >
                                <RaikoGridOneColumn>
                                    <RaikoNumberInputOutlined
                                        labelText={"کد ملی"}
                                        value={nationalCode}
                                        setValue={setNationalCode}
                                    />
                                    <RaikoMobileInputOutlined
                                        labelText={"شماره همراه"}
                                        value={phoneNumber}
                                        setValue={setPhoneNumber}
                                    />
                                </RaikoGridOneColumn>
                            </RaikoTableSearchContainer>

                            <RaikoCustomTable
                                header={header}
                                data={transactions}
                                pageCount={pageCount}
                                isLoading={tableLoading}
                                handlePaginationChange={handlePaginationChange}
                                rowClicked={handleShowDetail}

                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>

        </>
    )
}


const header = [
    {
        id: "number",
        label: "#"
    }, {
        id: "fullName",
        label: "نام و نام خانوادگی"
    }, {
        id: "nationalCode",
        label: "کدملی"
    }, {
        id: "phoneNumber",
        label: "شماره همراه"
    }, {
        id: "amount",
        label: "مبلغ(تومان)"
    }, {
        id: "paymentGatewayTitle",
        label: "درگاه پرداخت"
    }, {
        id: "createdAt",
        label: "تاریخ پرداخت"
    },
]